import type { ReactNode } from "react";

import "./ui.css";

export interface SegmentedFilterOption<T extends string> {
  value: T;
  label: ReactNode;
  dot?: "allow" | "block" | "unknown" | "default";
}

interface SegmentedFilterProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: SegmentedFilterOption<T>[];
  ariaLabel?: string;
}

export function SegmentedFilter<T extends string>({
  value,
  onChange,
  options,
  ariaLabel,
}: SegmentedFilterProps<T>) {
  return (
    <div className="seg" role="group" aria-label={ariaLabel}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={value === o.value}
          onClick={() => onChange(o.value)}
        >
          {o.dot && <span className={`dot dot--${o.dot}`} />}
          {o.label}
        </button>
      ))}
    </div>
  );
}
